module.exports = __webpack_public_path__ + "static/media/Victreebel_gaussian2.3a9bd578.png";